import React, { useState, useEffect } from 'react';
import './timeSlider.css';
import axiosInstance from '../../../utils/router/axiosInstance';
import { logger } from '../../../utils/logger';

const TimeSlider = ({ date, id, onTimeChange }) => {
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [selectedTime, setSelectedTime] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const [timeOptions, setTimeOptions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            if (date) {
                const [year, month, day] = date.split('-');

                try {
                    const response = await axiosInstance.get(`website/employee/time/${id}?date=${year},${month},${day},0,0`);
                    const times = response.data;
                    if (times.length > 0) {
                        const firstTime = times[0].begin;
                        const lastTime = times[times.length - 1].end;
                        setStartTime(firstTime);
                        setEndTime(lastTime);
                        setIsVisible(true);
                    }
                } catch (error) {
                    logger.error('Error fetching time data:', error);
                }
            }
        };

        fetchData();
    }, [date, id]);

    useEffect(() => {
        const timeRange = calculateTimeRange(startTime, endTime);
        const options = generateTimeOptions(timeRange, startTime);
        setTimeOptions(options);
    }, [startTime, endTime]);

    const handleChange = (event) => {
        const selectedTime = timeOptions[parseInt(event.target.value, 10)].label;
        setSelectedTime(parseInt(event.target.value, 10)); // Обновляем selectedTime
        onTimeChange(selectedTime); // Вызываем onTimeChange с выбранным временем
    };
    

    const selectedTimeString = timeOptions[selectedTime] ? timeOptions[selectedTime].label : '';

    return (
        <div style={{ display: isVisible ? 'block' : 'none' }}>
            <input
                className='selectTime'
                type='range'
                min={0}
                max={timeOptions.length - 1}
                value={selectedTime}
                onChange={handleChange}
            />
            <p>выбранное время: {selectedTimeString}</p>
            <p>здание: {localStorage.getItem('buildingName')}</p>
            <p>этаж: {localStorage.getItem('selectedFloor')}</p>
        </div>
    );
};

const calculateTimeRange = (startTime, endTime) => {
    if (!startTime || !startTime.includes(' ')) {
        return 0; 
    }

    const start = startTime.split(' ')[1].split(':').slice(0, 2).map(Number);
    const startdate = new Date(startTime.split(' ')[0]);

    const startMinutes = start[0] * 60 + start[1];

    let endMinutes;
    if (!endTime || !endTime.includes(' ')) {
        const currentDate = new Date();
        var daysAgo = Math.floor((currentDate - startdate)/(1000 * 60 * 60 * 24))
        endMinutes = daysAgo*1440+currentDate.getHours() * 60 + currentDate.getMinutes();
        logger.debug(daysAgo)
    } else {
        const end = endTime.split(' ')[1].split(':').slice(0, 2).map(Number);
        endMinutes = end[0] * 60 + end[1];
    }
    logger.debug(startdate)
    return endMinutes - startMinutes;
};




const generateTimeOptions = (timeRange, startTime) => {
    const timeOptions = [];
    if (!startTime || !startTime.includes(' ')) {
        return timeOptions; 
    }
    const [startHour, startMinute] = startTime.split(' ')[1].split(':').slice(0, 2).map(Number);
    let currentHour = startHour;
    let currentMinute = startMinute;
    
    for (let i = 0; i <= timeRange; i++) {
        const timeString = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;
        timeOptions.push({ value: i, label: timeString });
    
        currentMinute++;
        if (currentMinute === 60) {
            currentHour++;
            currentMinute = 0;
        }
    
        if (currentHour === 24) {
            currentHour = 0;
        }
    }
        
    return timeOptions;
};
    
    
    export default TimeSlider;